import axios from '@/modules/axios';
import { configAuthAxios } from '@/modules/axios/config';

const instance = axios.create({
  baseURL: `${process.env.PROXY_SERVER_URL}`,
});

function login(account) {
  return instance.post('/auth/login', account);
}

function logout(teamName) {
  return axios.get(`/accounts/logout/${teamName}`);
}


function loadUser(teamName) {
  configAuthAxios(teamName);
  return axios.get('/me');
}


export {
  login,
  logout,
  loadUser,
};



// WEBPACK FOOTER //
// ./src/modules/api/Auth.js